import { render } from "./CookieComplyModal.vue?vue&type=template&id=0f06bb99"
import script from "./CookieComplyModal.vue?vue&type=script&lang=js"
export * from "./CookieComplyModal.vue?vue&type=script&lang=js"

import "./CookieComplyModal.vue?vue&type=style&index=0&id=0f06bb99&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__